const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 */
const MarketingPreferenceResource = function (
    $resource,
    apiRequestParams,
    appConfig
) {
    return $resource(
        appConfig.apiBaseUrl + 'marketingpreferences',
        apiRequestParams.defaults(),
        {
            query: {
                isArray: true,
                method: 'GET',
                params: apiRequestParams.defaultMappers(),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'ReturnReason'),
            },
        }
    );
};

module.exports = MarketingPreferenceResource;
